import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

import ArrowLeftUrl from "../../assets/img/arrow-left.svg";
import ArrowRightUrl from "../../assets/img/arrow-right.svg";

import Card from "./Card";

SwiperCore.use([Navigation, Pagination]);

const SlidesContainer = styled.div`
	overflow-x: hidden;
	padding-bottom: ${rem(50)};
	padding-top: ${rem(50)};
	align-self: center;
	width: 100%;
	height: 100%;

	position: relative;

	// slider styles

	.swiper-container {
		height: 100%;
		overflow: visible;
		position: static;
		width: ${rem(995)};
		max-width: 90%;
	}

	.swiper-slide .card:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.4;
		transition: opacity 0.3s;
		pointer-events: none;
		z-index: 3;
	}

	.swiper-slide-active .card:after {
		opacity: 0;
	}

	.swiper-button-prev,
	.swiper-button-next {
		width: ${rem(74)};
		height: ${rem(74)};
		opacity: 1;
		z-index: 2;
		cursor: pointer;
		transition: transform 0.3s, opacity 0.3s;

		&:after {
			content: "";
			width: ${rem(40)};
			height: ${rem(40)};
			position: absolute;
			z-index: 1;
			background-size: ${rem(16)};
			background-repeat: no-repeat;
			background-position: center center;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(255, 255, 255, 0.5);
			backdrop-filter: blur(4px);
			border-radius: 999em;
			transition: transform 0.3s;
		}

		&:hover::before {
			transform: scale(1.1);
		}
	}

	.swiper-button-prev {
		left: calc((100% - ${rem(980)}) / 4);

		&:after {
			background-image: url(${ArrowLeftUrl});
			margin-left: ${rem(-3)};
		}

		&.swiper-button-disabled {
			transform: translateX(${rem(-20)});
			opacity: 0;
		}
	}

	.swiper-button-next {
		right: calc((100% - ${rem(980)}) / 4);

		&:after {
			background-image: url(${ArrowRightUrl});
			margin-left: ${rem(3)};
		}

		&.swiper-button-disabled {
			transform: translateX(${rem(20)});
			opacity: 0;
		}
	}

	.swiper-pagination-bullet {
		width: ${rem(14)};
		height: ${rem(14)};
		opacity: 0.34;
		background: #fff;
		transition: opacity 0.3s;

		&-active {
			opacity: 1;
		}
	}
`;

const Slider = ({ closeModal, items, initialSlide }) => {
	return (
		<React.Fragment>
			{items.length === 1 ? (
				<Card closeModal={closeModal} {...items[0]} />
			) : (
				<SlidesContainer>
					<Swiper
						navigation
						spaceBetween={35}
						pagination={{ clickable: true }}
						slidesPerView={1}
						initialSlide={initialSlide}
					>
						{items.map((item, index) => (
							<SwiperSlide key={index}>
								<Card closeModal={closeModal} {...item} />
							</SwiperSlide>
						))}
					</Swiper>
				</SlidesContainer>
			)}
		</React.Fragment>
	);
};

export default Slider;
